import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient){}

  getRollbackStatus(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getRollbackStatus).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  rollBack(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.weekendRollBack).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }
  
  rollForward(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.weekendRollForward).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }
}
